/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import { Container, Breadcrumb, Meta, Button, User, FormRow } from '../../../components'
import routes from './routes'
import { useViewport, viewportBreakpoint } from '../../../utils'
import { useLocation } from 'react-router-dom'
import { ShareButtons } from './share-buttons'
// import { ActionButtons } from './action-buttons'

const TypeFile = ({data}) => {
  const location = useLocation()
  const special = location.search.includes('special')
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const imageWidth = '100%'
  const height = isMobile ? '235px' : '470px'

  const downloadFile = () => {
    if(data.attachmentUrl){
      window.location.href = data.attachmentUrl
    }
  }

  return (
    <Container className="py-5 pb-8 lg:pb-20 lg:py-20" color="#f5f5f5">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-5/12 mb-5 lg:mb-0 px-4">
          <div
            style={{width: imageWidth, height: height, backgroundImage: `url('${data.image}')`}}
            className="bg-no-repeat bg-cover bg-center rounded"
          />
          {/* <img src="/images/resource/khub_resource_detail.jpg" alt="resource" className="rounded"/> */}
        </div>
        <div className="lg:w-6/12 px-4 ml-auto">
          <div className="mb-3">
            <Breadcrumb routes={routes} />
          </div>
          <div className="lg:hidden">
            <div className="text-xs font-bold mb-3">{data.date}</div>
          </div>
          {
            special &&
            <div className="rounded px-1 text-white text-xs mb-4 inline-block" style={{background: '#FF5448'}}>Special Resource</div>
          }
          <h1 className="text-2xl lg:text-4xl font-bold font-primary mb-4 lg:mb-5 leading-tight">
            {data.title}
          </h1>
          <div className="w-3/4 lg:w-full flex flex-wrap -mx-2 lg:-mx-4 mb-1 lg:mb-8">
            {
              data.type &&
              <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
                <Meta
                  className="mb-4 lg:mb-0"
                  label="Type"
                  value={data.type}
                />
              </div>
            }
            {/* <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
              <Meta
                className="mb-4 lg:mb-0"
                label="Suitable for"
                value="Educator, Donor, Professionals"
              />
            </div> */}
            {
              data.approach &&
              <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
                <Meta
                  className="mb-6 lg:mb-0"
                  label="Approach"
                  value={data.approach}
                />
              </div>
            }
            {
              data.issues &&
              <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
                <Meta
                  className="mb-6 lg:mb-0"
                  label="Issues"
                  value={data.issues}
                />
              </div>
            }
          </div>
          {
            data.organization &&
            <FormRow>
              <User name={data.organization} />
            </FormRow>
          }
          <hr className="my-6 lg:my-10" style={{ borderColor: '#ddd' }}/>
          <div className="blog-content text-sm mb-5 lg:mb-10" dangerouslySetInnerHTML={{
            __html: data.content
          }} />

          {
            data.type === 'file' &&
            <div className="flex flex-wrap -mx-2 lg:-mx-4 mb-4 lg:mb-8">
              <div className="w-full lg:w-1/2 px-2 lg:px-4">
                <Button className="hidden lg:block" onClick={downloadFile}>
                  Download
                </Button>
                <div className="lg:hidden">
                  <Button thin onClick={downloadFile}>
                    Download
                  </Button>
                </div>
              </div>
            </div>
          }

          {/* <ActionButtons /> */}

          <hr className="my-8 lg:my-10"/>
          <ShareButtons />
        </div>
      </div>
    </Container>
  )
}

export { TypeFile }